import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  PROMO_CODE_VERIFICATION_STATUS,
  promoCodeType,
} from '../../features/promotions/types/promotionTypes';
import { usePromotionsContext } from '../../hooks/usePromotionsContext';
import { FormattedMessage } from 'react-intl';

const PromoCodeCards = () => {
  const [hidePromoCodes, setHidePromoCodes] = useState<boolean>(true);
  const [disabledPromoCodes, setDisabledPromoCodes] = useState<boolean>(false);
  const {
    promoCodeWidgetData,
    onPromoCodeApply,
    availablePromoCodes,
    promoCodesWithTriggeringRule,
  } = usePromotionsContext();

  const { appliedPromoCode, promoVerificationStatus } = promoCodeWidgetData;
  const { appliedPromotionsData } = usePromotionsContext();

  useEffect(() => {
    const appliedPromotions = appliedPromotionsData?.appliedPromotions || [];
    if (appliedPromotions.length) {
      setDisabledPromoCodes(true);
    } else {
      setDisabledPromoCodes(false);
    }
  }, [appliedPromotionsData?.appliedPromotions]);

  useEffect(() => {
    if (appliedPromoCode !== '') {
      setHidePromoCodes(true);
    } else {
      setHidePromoCodes(false);
    }
  }, [appliedPromoCode]);

  const handlePromoClick = (promocode: promoCodeType) => {
    if (disabledPromoCodes) {
      return;
    }
    if (!promocode.condition_fullfilled) {
      return;
    }
    onPromoCodeApply(promocode.code);
  };

  const sortedPromoCodes = useMemo(() => {
    return [...promoCodesWithTriggeringRule].sort(
      (a, b) => Number(b.condition_fullfilled) - Number(a.condition_fullfilled)
    );
  }, [promoCodesWithTriggeringRule]);

  // Early return if promo code is applied
  if (hidePromoCodes || !availablePromoCodes.length) {
    return <></>;
  }

  return (
    <>
      {sortedPromoCodes.length ? (
        <div
          className='widget mb-3 promo-code-cards-widget'
          key={'promo-codes-list'}
        >
          <div>
            <p className='input-label bold mb-0'>
              <FormattedMessage
                id='promotion.select_promo_code'
                defaultMessage='Select Promo Code'
              />
            </p>
          </div>
          <div className='promo-codes-list'>
            {sortedPromoCodes.map((code) => (
              <div
                className={`coupon-wrapper ${
                  code.condition_fullfilled && !disabledPromoCodes
                    ? ''
                    : 'disabled'
                }`}
                onClick={() => handlePromoClick(code)}
                key={code.id}
              >
                <div className='coupon'>
                  <div className='code'>{code.code}</div>
                  <div className='discount'>{code.name}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default PromoCodeCards;
